import { OptionsClass } from "@/domain/entities/MainApp";

export const sourceDex = {
  series: [0, 0],
  color: ["#4185F7", "#9BC4FA"],
  detail: [
    {
      name: "driverApp",
      value: 0,
      color: "#4185F7",
      originKey: "sourceDriverApp",
      percentage: 0
    },
    {
      name: "genesis",
      value: 0,
      color: "#9BC4FA",
      originKey: "sourceGenesis",
      percentage: 0
    }
  ]
};

export const attemptDex = {
  series: [0, 0, 0],
  color: ["#D4797C", "#E13E49", "#B82025"],
  detail: [
    {
      name: "one",
      value: 0,
      color: "#D4797C",
      originKey: "attemptOne",
      percentage: 0
    },
    {
      name: "two",
      value: 0,
      color: "#E13E49",
      originKey: "attemptTwo",
      percentage: 0
    },
    {
      name: "more",
      value: 0,
      color: "#B82025",
      originKey: "attemptThreePlus",
      percentage: 0
    }
  ]
};

export const rtsDex = [
  {
    key: "totalRts",
    titleKey: "sectionPercentageRtsDex",
    total: new OptionsClass({
      key: "totalRts",
      value: "0"
    }),
    percentage: {
      key: "percentageRts",
      value: "0"
    }
  }
];

export const sortOptions: any = {
  dex: [
    { nameKey: "sortOrder", sortBy: "", orderBy: "", value: "" },
    {
      nameKey: "sortTotalDexHighest",
      sortBy: "desc",
      orderBy: "total_dex",
      value: "total_dex_desc"
    },
    {
      nameKey: "sortTotalInvalidHighest",
      sortBy: "desc",
      orderBy: "total_invalid",
      value: "total_invalid_desc"
    },
    {
      nameKey: "sortTotalRejectedHighest",
      sortBy: "desc",
      orderBy: "total_rejected",
      value: "total_rejected_desc"
    },
    {
      nameKey: "sortTotalDexLowest",
      sortBy: "asc",
      orderBy: "total_dex",
      value: "total_dex_asc"
    },
    {
      nameKey: "sortTotalInvalidLowest",
      sortBy: "asc",
      orderBy: "total_invalid",
      value: "total_invalid_asc"
    },
    {
      nameKey: "sortTotalRejectedLowest",
      sortBy: "asc",
      orderBy: "total_rejected",
      value: "total_rejected_asc"
    }
  ],
  courier: [
    { nameKey: "sortOrder", sortBy: "", orderBy: "", value: "" },
    {
      nameKey: "sortTotalInvalidHighest",
      sortBy: "desc",
      orderBy: "total_invalid",
      value: "total_invalid_desc"
    },
    {
      nameKey: "sortCourierRejectedHighest",
      sortBy: "desc",
      orderBy: "total_rejected",
      value: "total_rejected_desc"
    },
    {
      nameKey: "sortTotalInvalidLowest",
      sortBy: "asc",
      orderBy: "total_invalid",
      value: "total_invalid_asc"
    },
    {
      nameKey: "sortCourierRejectedLowest",
      sortBy: "asc",
      orderBy: "total_rejected",
      value: "total_rejected_asc"
    },
  ]
}

export const statusOptions: any = {
  dex: [
    { nameKey: "statusAll", name: "All Status", value: "", color: "" },
    {
      nameKey: "statusDexValid",
      name: "DEX Valid",
      value: "total_valid",
      color: "#7ACB90"
    },
    {
      nameKey: "statusDexInvalid",
      name: "DEX Invalid",
      value: "total_invalid",
      color: "#D4797C"
    },
    {
      nameKey: "statusDexRequested",
      name: "DEX Invalid Disanggah",
      value: "total_requested",
      color: "#FFCB01"
    },
    {
      nameKey: "statusDexApproved",
      name: "DEX Invalid Sanggah Disetujui",
      value: "total_approved",
      color: "#8E78DB"
    },
    {
      nameKey: "statusDexRejected",
      name: "DEX Invalid Sanggah Ditolak",
      value: "total_rejected",
      color: "#EF7C5C"
    }
  ],
  courier: [
    { nameKey: "statusAll", name: "All Status", value: "", color: "" },
    {
      nameKey: "statusDexInvalid",
      name: "DEX Invalid",
      value: "total_invalid",
      color: "#D4797C"
    },
    {
      nameKey: "statusDexAccepted",
      name: "DEX Invalid Diterima",
      value: "total_accepted",
      color: "#58C5E2"
    },
    {
      nameKey: "statusDexRequested",
      name: "DEX Invalid Disanggah",
      value: "total_requested",
      color: "#FFCB01"
    },
    {
      nameKey: "statusDexApproved",
      name: "DEX Invalid Sanggah Disetujui",
      value: "total_approved",
      color: "#BC9AFD"
    },
    {
      nameKey: "statusDexRejected",
      name: "DEX Invalid Sanggah Ditolak",
      value: "total_rejected",
      color: "#EF7C5C"
    },
  ]
}